import { FC } from "react"
import { FilesList } from "../../../../module/settings/containers/files/list"

export const FilesListPage: FC = () => <FilesList />
